import { Link } from "react-router-dom";
import { ArrowRight } from "@phosphor-icons/react";
import * as Ph from "@phosphor-icons/react";

export default function ServiceCard({ service }) {
  const Icon = Ph[service.icon] || Ph.Wrench;
  return (
    <Link
      to={`/services/${service.slug}`}
      data-testid={`service-card-${service.slug}`}
      className="group relative block rounded-sm border border-[#E2E8F0] bg-white p-6 md:p-8 transition-all duration-200 hover:-translate-y-1 hover:border-[#FF6B00] hover:shadow-xl"
    >
      <span
        className="absolute left-0 top-0 h-full w-1 bg-[#FF6B00] opacity-0 transition-opacity group-hover:opacity-100"
        aria-hidden
      />
      <div className="inline-flex h-12 w-12 items-center justify-center rounded-sm bg-[#1B2A4A] text-white">
        <Icon size={24} weight="fill" className="text-[#FF6B00]" />
      </div>
      <h3 className="mt-5 font-display font-black text-xl md:text-2xl text-[#1B2A4A] tracking-tight">
        {service.name}
      </h3>
      <p className="mt-3 text-sm md:text-base text-[#4B5563] leading-relaxed">
        {service.shortDesc}
      </p>
      <div className="mt-6 inline-flex items-center gap-2 text-sm font-bold font-display text-[#FF6B00] uppercase tracking-wider">
        Learn more
        <ArrowRight size={16} weight="bold" className="transition-transform group-hover:translate-x-1" />
      </div>
    </Link>
  );
}
